module.exports = __webpack_public_path__ + "img/LUIS_CALDAS.82c5367f.jpeg";